import { apiClientGeral, apiClientAudio, apiCallCenter, apiPesquisaSatisfacao } from '@/plugins/axios'

export default {
  getUras() {
    return apiClientGeral().get('/ura')
  },
  getWebhooks() {
    return apiCallCenter().get('/webhook')
  },
  getAudios() {
    return apiClientAudio().get('/audio')
  },
  getAllRegex() {
    return apiClientAudio().get('/alliasregex')
  },
  getCentroDeCustos() {
    return apiClientGeral().get('/centrodecusto')
  },
  getGruposRamais() {
    return apiClientGeral().get('/gruposatendimento')
  },
  getTroncos() {
    return apiClientGeral().get('/troncos')
  },
  getConferencias() {
    return apiClientGeral().get('/conferencias')
  },
  getFilas() {
    return apiCallCenter().get('/queue/lazy')
  },
  getMusicasEmEspera() {
    return apiClientAudio().get('/musica')
  },
  getTodasPesquisasSatisfacao() {
    return apiPesquisaSatisfacao().get('/satisfacao/lazy')
  },
  getTags() {
    return apiClientGeral().get('/tags')
  },
  getrotas() {
    return apiClientGeral().get('/rotasentrada')
  },
}
